import { MachineCategory } from './machine-category.type';
import { Monitor } from './monitor.type';

export class Machine {
  PhysicalAddress: string = null;
  UserId: string = null;
  Title: string = null;
  Version: string = null;
  ShowPrimaryScreen: boolean = null;
  IsSelected: boolean;
  IsAndroid: boolean;
  RotationMode: number;
  AndroidMode: number;
  CategoryId: number;
  Category: MachineCategory;
  IpAddress: string;

  Monitors: Monitor[] = null;
  LastSeen?: string;
  isActive: boolean;

  constructor(params: Partial<Machine> = {}) {
    Object.assign(this, params);
  }
}
